module.exports = __webpack_public_path__ + "static/media/auditing-sensitivity.c0374ca9.jpg";